import { render } from "./BundlePreview.vue?vue&type=template&id=377bd9b8&scoped=true"
import script from "./BundlePreview.vue?vue&type=script&lang=js"
export * from "./BundlePreview.vue?vue&type=script&lang=js"

import "./BundlePreview.vue?vue&type=style&index=0&id=377bd9b8&scoped=true&lang=scss"
import "./BundlePreview.vue?vue&type=style&index=1&id=377bd9b8&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377bd9b8"]])

export default __exports__